// Determine mode: dev/prod and test/live
const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';
export const isTestMode = import.meta.env.VITE_STRIPE_TEST_MODE !== undefined
  ? import.meta.env.VITE_STRIPE_TEST_MODE === 'true'
  : isDev;

const STRIPE_LINKS = {
  starter: {
    test: import.meta.env.VITE_STRIPE_LINK_STARTER_TEST || '',
    prod: import.meta.env.VITE_STRIPE_LINK_STARTER_PROD || '',
  },
  business: {
    test: import.meta.env.VITE_STRIPE_LINK_BUSINESS_TEST || '',
    prod: import.meta.env.VITE_STRIPE_LINK_BUSINESS_PROD || '',
  },
};

export const getStripeUrl = (plan: 'starter' | 'business'): string => {
  const links = STRIPE_LINKS[plan];
  return isTestMode ? links.test : links.prod;
};
